import "../../../assets/styles/containers/_commentTags.scss";

const CommentTags = ({ tags, selectedFilterTagID }) => {
  const filteredTags = tags?.filter(tag => {
    const tagId = tag?.tag?.id || tag?.id;
    return !selectedFilterTagID?.includes(tagId);
  });

  function getContrastTextColor(hexColor) {
    hexColor = hexColor.replace('#', '');
    if (hexColor.length === 3) {
      hexColor = hexColor.split('').map(c => c + c).join('');
    }
    const r = parseInt(hexColor.substring(0, 2), 16) / 255;
    const g = parseInt(hexColor.substring(2, 4), 16) / 255;
    const b = parseInt(hexColor.substring(4, 6), 16) / 255;
    const linear = [r, g, b].map(c =>
      c <= 0.03928
        ? c / 12.92
        : Math.pow((c + 0.055) / 1.055, 2.4)
    );
    const luminance =
      0.2126 * linear[0] +
      0.7152 * linear[1] +
      0.0722 * linear[2];
    return luminance > 0.5 ? "#000000" : "#FFFFFF";
  }

  return (
    <div className="comment_tags_container">
      {filteredTags?.map((tag, index) => (
        <div
          key={index}
          className="comment_tag"
          style={{
            backgroundColor: tag?.tag?.color || tag?.color || "#000000",
            color: getContrastTextColor(tag?.tag?.color || tag?.color),
          }}
        >
          {tag?.tag?.name || tag?.name || tag?.title}
        </div>
      ))}
    </div>
  );
};

export default CommentTags;
